import React        from 'react';
import { connect } from 'react-redux';
import "scroll-behavior-polyfill";

import CSSModules from 'react-css-modules';
import Helmet     from "react-helmet";

import style from './style.scss';

import Footer               from '../Footer';
import Header               from '../Header';
import MarketingModuleList  from '../MarketingModuleList';
import MarketingCourseList  from '../MarketingCourseList';
import UpcomingEventsCourses       from '../UpcomingEventsCourses';
import HomePageSlider       from '../HomePageSlider';
import MarketingInfo        from '../MarketingInfo';
import MarketingAdvert      from '../MarketingAdvert';

import * as marketingActions from '../../actions/marketingPage';

class MarketingPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            closeCoursePanel: false
        }
    }

    componentDidMount() {

        this.setState({closeCoursePanel: false})
        this.props.refreshModules();

    }

    _handleScrollUp() {

        const ele = document.getElementById('subject-tile-list');
        const header = document.getElementById('menu-header');
        const rect = ele.getBoundingClientRect();

        let scrollTo = rect.top - header.offsetHeight - 85;

        window.scrollBy({
            top: scrollTo,
            behavior: 'smooth'
        });

    }

    _handleScrollDown() {

        const ele = document.getElementById('course-tile-list');
        const header = document.getElementById('menu-header');
        const rect = ele.getBoundingClientRect();

        let scrollTo = rect.top - (header.offsetHeight + 15);

        window.scrollBy({
            top: scrollTo,
            behavior: 'smooth'
        });
    }

    _getMetaDescription() {

        return {
            "name": "description",
            "content": "Considered, effective training courses for those at the sharp end. " +
            "Public, private and third sector staff – our aim is to connect those with a need to a " +
            "person who can help. CPD accredited events at home or away."
        };
    }

    _moduleSelected(selectedModule) {

        this.setState({closeCoursePanel: false});
        this.props.moduleSelected(selectedModule);
        this._handleScrollDown();
    }

    _closeCoursePanel() {

        this.setState({closeCoursePanel: true});
        this.props.moduleSelected(null);
        this._handleScrollUp();
    }

    render() {

        const showCourseSection = !this.state.closeCoursePanel && this.props.selectedModule && this.props.selectedModule.courses.length > 0;
        return (
            <div>

                <Helmet title="Training for Government Business and Professionals"
                        meta={[ this._getMetaDescription() ]} />

                <div className={style['content']}>

                    <Header />

                    <HomePageSlider modules={this.props.modules}/>

                    <MarketingAdvert backgroundColor="#f0f03c" />

                    <MarketingInfo />

                    <UpcomingEventsCourses />

                    <article className={style['section--module']}>

                        <div className={style['section-content']}>

                            <MarketingModuleList
                                selectedModule={this.props.selectedModule}
                                onClick={this._moduleSelected.bind(this)}
                                modules={this.props.modules}
                            />

                        </div>

                    </article>

                    <div id="course-tile-list">
                        {showCourseSection && (<article className={style['section--course']}>

                            <div className={style['section-content']}>

                                <MarketingCourseList
                                    selectedModule={this.props.selectedModule}
                                    onCloseClick={this._closeCoursePanel.bind(this)}
                                />

                            </div>

                        </article>)}
                    </div>

                    <article className={style['delegates-trained']}>

                        <div className={style['section-content']}>

                            <div className={style['padded--content']}>

                                <h2 className={style['delegates-trained__heading']}>Delegates</h2>

                                <div className={style['delegates-trained__stats']}>

                                    <span className={style['delegates-statistic-caption']}>
                                        Delegates trained on RHE courses since 2010
                                    </span>

                                    <img className={style['delegates-statistic']}
                                         src="/assets/images/icons/1874_6000+_white.png" />
                                </div>

                                <div className={style['delegates-trained__testimonial']}>

                                    <span className={style['featured-testimonial__quote-icon']}>“</span>

                                    <span className={style['featured-testimonial__content']}>
                                        Excellent training day, very useful to relate the content to actual real life jobs. Very good, all round course.
                                    </span>

                                    <span className={style['featured-testimonial__author']}>
                                        Environmental Protection Officer, Craven District Council
                                    </span>

                                </div>

                                <div className={style['delegates-info__box']}>

                                    <span className={style['featured-testimonial__content']}>
                                        All RHE training courses qualify for Continuing Professional Development hours. CPD Certificates are awarded to all delegates on the day of the course.
                                    </span>

                                </div>

                            </div>

                        </div>

                    </article>

                    <article className={style['organisations-section']}>

                        <div className={style['section-content']}>

                            <div className={style['padded--content']}>

                                <h2 styleName="organisation__heading">Organisations</h2>

                                <div styleName="organisations-section__text">

                                    <span styleName="organisations-statistic-caption">
                                        Organisations using RHE training courses since 2010
                                    </span>

                                    <img styleName="organisations-statistic"
                                         src="/assets/images/icons/statistic_400_blue.png" />

                                </div>

                                <div styleName="organisation-section-logo__box">

                                    <img src="/assets/images/organisations/logos/cornwall_council_logo.png" className={style['organisation-section-logo']} />

                                </div>

                                <div styleName="organisations-section__testimonial">

                                    <span styleName="featured-testimonial__quote-icon">“</span>

                                    <span styleName="featured-testimonial__content">
                                        An excellent course with a very knowledgeable tutor. The course content was comprehensive, effective and engaging.
                                    </span>

                                    <span styleName="featured-testimonial__author">
                                        Business Development Specialist, Cornwall Council
                                    </span>

                                </div>
                            </div>

                        </div>

                    </article>

                </div>

                <Footer />

            </div>
        );
    }
}

function mapStateToProps(state) {

    return {
        selectedModule: state.marketingPage.selectedModule,
        modules: state.marketingPage.modules,
    }
}

function mapDispatchToProps(dispatch) {

    return {
        moduleSelected(module) {

            dispatch(marketingActions.moduleSelected(module));
        },
        refreshModules() {

            dispatch(marketingActions.refreshModules());
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(MarketingPage, style));


// WEBPACK FOOTER //
// ./components/MarketingPage/index.js